import { useMutation, useQueryClient } from '@tanstack/react-query';

import { DocsRequestPayload } from '../../../../../types';
import { handleSuccess } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { postRequestApplicationDocs } from '../../requests/postRequestApplicationDocs';

export const useRequestApplicationDocs = (definitionName: string) => {
  const queryClient = useQueryClient();
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: requestDocs, ...rest } = useMutation({
    mutationFn: ({ uuid, data }: { uuid: string; data: DocsRequestPayload }) =>
      postRequestApplicationDocs(constructPost, uuid, definitionName, data),
    onSuccess: (_, { uuid }) => {
      handleSuccess('Success');
      queryClient.invalidateQueries({
        queryKey: [APPLICATION_BASE_PATH, uuid, 'docs-tab'],
      });
    },
  });

  return { requestDocs, ...rest };
};
